import 'client-only';
import {instanceType} from './Popover.type';
import {getScrollbarWidth} from '@utils/getScrollbarWidth';

export function disableScrollOnPopover(
  {id, visible}: {id: number; visible: boolean},
  instances: instanceType[]
) {
  let newInstance = instances;
  const bodyElement = document.querySelector('body');
  if (!bodyElement) return newInstance;

  const registeredId = newInstance.findIndex(({id: i}) => i === id);

  const isAnyInstanceVisible = newInstance.find(
    ({visible, id: i}) => visible && i !== id
  );
  const currentIndex =
    registeredId < 0
      ? newInstance.length
      : newInstance.findIndex(({id: i}) => i === id);

  if (!isAnyInstanceVisible) {
    if (visible) {
      bodyElement.style.overflow = 'hidden';
      const scrollbarWidth = `${getScrollbarWidth()}px`;
      bodyElement.style.paddingRight = scrollbarWidth;
    } else {
      bodyElement.style.overflow = 'auto';
      bodyElement.style.paddingRight = '0px';
    }
  }

  if (currentIndex > -1 && !(registeredId < 0 && !visible))
    newInstance[currentIndex] = {
      id,
      visible,
    };

  return newInstance;
}
